import 'whatwg-fetch';
import { api, jumboQAtransbank } from 'config';
import StorageService from 'services/StorageService';
import PubSub from 'services/PubSub';
import Log from 'services/Log';
import LoginService from 'services/Login';
import TagManagerService from "services/TagManager";
import {walletPaymentsName, paymentsName} from "config/index";
import NewRelicService from 'services/NewRelic'

let selectedToken = null;
let statusAttempts = 0;
const timeAttempts = 10000;
const msgAttempts = [
    'Tu pago está siendo procesado, espera un momento.',
    'Aún no hemos terminado, espera un momento.'
];

const selectCard = (card) => {
    if(!card) return false;
    selectedToken = card.token;
}

const _sendPurchase = (tId) => {
    const token = StorageService.getItem('sessionData');

    const payload = {
        "idCard": selectedToken,
        "tId": tId
    };

    return fetch(api.wallet + `/wallet/transaction`, {
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
    }).then(data => data.json())
        .catch(err => {
            Log.captureException(err);
            return false
        });
}

const purchase = (tId = null) => {
    return _sendPurchase(tId).then(data => {
        if(data && data.internalCode === '200-2'){
            statusAttempts = 0;
            return _getPaymentStatus(tId);
        }

        NewRelicService.sendPageAction({
            action: 'walletPayment',
            payload: {
                status: 'success',
                tId,
                internalCode: data ? data.internalCode : null
            }
        });

        return data;
    });
}

const __getPaymentStatus = (tid) => {
    if(!tid){
        return Promise.reject(false);
    }

    const token = StorageService.getItem('sessionData');

    return fetch(api.wallet + `/wallet/status/${tid}`, {
        headers: {
            'x-api-key': api.apiKey,
            'pragma': 'no-cache',
            'token': token,
            'cache-control': 'no-cache',
            'Content-Type': 'application/json'
        }
    }).then(data => data.json());
}

const _getPaymentStatus = (tid) => {
    NewRelicService.sendPageAction({
        action: 'walletPayment',
        payload: {
            status: 'inProgress',
            tId: tid
        }
    });
    _sendNotification(msgAttempts[statusAttempts]);
    return new Promise(resolve => {
        setTimeout(()=> {
            __getPaymentStatus(tid).then(data => {
                if(data && data.internalCode === '200-2'){
                    statusAttempts++;
                    resolve(_getPaymentStatus(tid));
                    return false;
                }
                NewRelicService.sendPageAction({
                    action: 'walletPayment',
                    payload: {
                        status: 'success',
                        tId: tid
                    }
                });
                resolve(data);
            });
        },timeAttempts);
    });
}

const _sendNotification = (msg) => {
    if(!msg) return false;
    setTimeout(() => {
        PubSub.dispatch('open_snackbar',{
            TitleMobile: msg,
            TitleDesktop: msg,
            timer: 15000,
            type: 'wallet'
        });
    },0);
}

const getWalletCards = () => {
    const token = LoginService.getUserToken();
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    return fetch(api.wallet + `/wallet/cards`, {
        method: 'GET',
        headers
    }).then(data => data.json());
}

const deleteWalletCard = (cardToken) => {
    const token = LoginService.getUserToken();
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    return fetch(api.wallet + `/wallet/card/${cardToken}`, {
        method: 'DELETE',
        headers
    }).then(data => data.json());
}

const isFavoriteWalletCard = (cardToken) => {
    const token = LoginService.getUserToken();
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    return fetch(api.wallet + `/wallet/card/${cardToken}`, {
        method: 'PUT',
        headers
    }).then(data => data.json());
}

const addWalletCard = (paymentMethod, bin = false) => {
    const token = LoginService.getUserToken();
    const userData = StorageService.getSecureItem('userData');
    const callback = window.location.href || null;
    let payload = {
        'email': userData.email,
        'firstName': userData.firstName,
        'lastName': userData.lastName,
        'callback': callback
    }
    if(bin){
        payload.bin = bin;
    }
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }
    return fetch(api.wallet + `/wallet/card/${paymentMethod}`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
    }).then(data => data.json());
}

const sendGtm = (methodId) => {
    if (methodId === walletPaymentsName.oneClick) {
        const actionField = {
            'step': 4,
            'option': paymentsName.oneClick
        };

        TagManagerService.onCheckoutOption(actionField);
    } else {
        const actionField = {
            'step': 4,
            'option': paymentsName.catOneClick
        };
        TagManagerService.onCheckoutOption(actionField);
    }
}

const WalletService = {
    selectCard,
    purchase,
    getWalletCards,
    deleteWalletCard,
    isFavoriteWalletCard,
    addWalletCard,
    sendGtm
}

export default WalletService;
